import { customAccessFunction } from 'charts/common/access';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from 'charts/common/hooks';
import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { useCallback, useMemo } from 'react';
import { useProcesses } from 'store/process';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { mapValuesAndLabels } from 'charts/model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useOriginator(): IssueChartContext {
  const processesWithOriginator = useProcessesWithField(
    IssueFieldNames.subcontractors
  );
  const access = useCallback(() => {
    return Boolean(processesWithOriginator.length);
  }, [processesWithOriginator]);
  // The filters offer all the user's processes, not only those with the chart's field.
  const { processes } = useProcesses();
  const filters = useIssueChartFilters({ chart: IssueChart.originator, processes });
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.originator, filters, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.originators,
    chartType: ChartType.donut,
    canAccess: customAccessFunction(access),
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
